import TabToggleList from 'components/commons/tab-toogle-list'
import { Button, InlineError, Input, Spinner } from 'avo-ui'
import icAddSquare from 'assets/images/ic-add-square.svg'
import TextEditor from 'components/commons/text-editor'

export const FAQ = ({ items, setItems, onChangeItem, onAddNewItem, errorForm, isLoading, isUpdating, onSubmit }) => {
    const getError = (key, index) => {
        const findError = errorForm?.faqs_detail?.find((i) => i?.index === index && i?.key === key)
        return findError?.message
    }

    return (
        <div className={'flex flex-col space-y-3 px-9 py-4'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex flex-col space-y-6'}>
                        {items?.map((item, index) => (
                            <TabToggleList
                                key={`faq-${index}`}
                                index={index}
                                title={`FAQ-Item-${index + 1}`}
                                content={
                                    <div className={'flex flex-col space-y-5'}>
                                        <div className={'flex flex-col space-y-3'}>
                                            <div className={'font-semibold text-blue-90 required'}>Pertanyaan</div>
                                            <Input
                                                className={'flex-1'}
                                                name={'question'}
                                                placeholder={'Masukkan pertanyaan'}
                                                value={item?.question}
                                                onChange={(item) => onChangeItem({ ...item, index })}
                                            />
                                            <InlineError className='mt-2' message={getError('question', index)} />
                                        </div>
                                        <div className={'flex flex-col space-y-3'}>
                                            <div className={'font-semibold text-blue-90 required'}>Jawaban</div>
                                            <div className={'flex-1 space-y-3'}>
                                                <TextEditor
                                                    className={'!h-fit'}
                                                    defaultValue={item?.answer || '<p></p>'}
                                                    onChange={(value) => onChangeItem({ name: 'answer', value, index })}
                                                    placeholder={'Isi uraian jawaban'}
                                                />
                                                <InlineError message={getError('answer', index)} />
                                            </div>
                                        </div>
                                    </div>
                                }
                                items={items}
                                setItems={setItems}
                                isDisableDelete={items?.length === 1}
                            />
                        ))}
                        <InlineError className='mt-2' message={errorForm?.faqs} />
                        <Button
                            className={'w-fit'}
                            type={'outline'}
                            icon={icAddSquare}
                            title={'Add New Item'}
                            onClick={onAddNewItem}
                        />
                    </div>
                    <div className={'flex py-3 justify-center'}>
                        <Button className={'w-[200px]'} loading={isUpdating} title={'Submit'} onClick={onSubmit} />
                    </div>
                </>
            )}
        </div>
    )
}
